<xi-generic-modal
  [canBackdropClose]="false"
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="600px"
  (onClose)="close()"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children" *transloco="let t; read: 'field-type-dialog'">
        <div class="xi-modal__container field-type__container">
          <h2 class="xi-modal__title">{{ t('metadata-field-configuration') }}</h2>

          <div class="xi-modal__content">
            <table>
              <tr>
                <td>
                  <div class="field-type__block-title">{{ t('name') }}</div>
                  <div class="field-type__block-name">
                    <xi-input-field
                      required
                      [(ngModel)]="metadataField.fieldName"
                      [status]="fieldNameStatus"
                      (onChange)="onValidateFieldName(metadataField)"
                      icon="cancel"
                      (onIconClick)="
                        metadataField.fieldName = ''; onValidateFieldName(metadataField)
                      "
                    ></xi-input-field>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="field-type__block-title">{{ t('type') }}</div>
                  <div class="field-type__block-type">
                    @for (option of fieldTypeOptions; track option) {
                      <div>
                        <xi-radio
                          name="groupNameTest"
                          [value]="option.value"
                          [(ngModel)]="metadataField.fieldType"
                          [label]="option.label"
                          (onChange)="setOptionDetail(metadataField, option)"
                          [checked]="option.value === metadataField.fieldType"
                          >{{ option.label }}</xi-radio
                        >
                      </div>
                    }
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="field-type__block-title">{{ t('details') }}</div>
                  <div class="field-type__block-detail">
                    {{ metadataField.typeDetail }}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="field-type__label">{{ t('is-filterable') }}</span>
                  <span>
                    <xi-toggle-switch
                      id="field-view__filterable"
                      [isToggled]="metadataField.filterable"
                      (onToggle)="metadataField.filterable = !metadataField.filterable"
                      [leftText]="t('no')"
                      [rightText]="t('yes')"
                    ></xi-toggle-switch>
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <div class="xi-modal__actions field-type__actions">
            <xi-default-button
              [text]="t('close')"
              fill="text"
              (onClick)="close()"
            ></xi-default-button>

            <xi-default-button
              [text]="t('configure')"
              [disabled]="!isComplete()"
              (onClick)="confirm()"
            ></xi-default-button>
          </div>
        </div></div
    ></xi-basic-tile></div
></xi-generic-modal>
